/**
 * Core Application Bundle
 * @author Rhys Lloyd
 */

// Babel Polyfill
import 'babel-polyfill';

//
// Dependencies
import * as registry from './registry';
const Vue = window.Vue;

import debug from "debug";
const MODULE_NAME = registry.CORE_MODULE;
const log = debug(MODULE_NAME);

// Set Vue Delimiters
Vue.config.delimiters = ['${', '}'];
Vue.config.unsafeDelimiters = ['${!', '!}'];

//
// Local Dependencies
log('Load dependencies...');
import modules from '@core/modules';
// import * as vendor from '@core/vendor';
import "@core/plugins";
//
// Dynamic Module Loaders
import dynamicLoadPsQuoteForm from './modules/ps-quote-form/dynamic-load';

import * as foundation from '@core/vendor/foundation';
//
// Constants

//
// Register
if (!registry.exists(MODULE_NAME)) {
	registry.register(MODULE_NAME, registry.STATE.LOADING);
}

/**
 * Loads dynamic modules (polyfills etc.)
 */
export function loadDynamicModules () {
	//
	// Dynamic Modules
	log('Load dynamic modules...');

	dynamicLoadPsQuoteForm();

	log('...dynamic modules done.');
}

//
// Application
/**
 * Execute Core Application
 */
export function exec () {

	$(document).ready(() => {
		log('Running document ready tasks...');

		// Run Foundation
		foundation.exec();

		// Run Modules
		modules();
	});
}

export { exec as default };
registry.setState(MODULE_NAME, registry.STATE.LOADED);

//
// Conditionally Self Execute
if (!registry.isRegistered(MODULE_NAME)) {
	exec();
	loadDynamicModules();
	registry.setState(MODULE_NAME, registry.STATE.REGISTERED);
}




// WEBPACK FOOTER //
// ./project/client/src/core/core.app.js